/* eslint-disable react/jsx-no-undef */
import React from "react";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import registerStep2 from '../../assets/images/register/register-step-2-4.svg';
import shop from "../../assets/images/register/shop.png";
import lineIcon from "../../assets/images/register/bi_line.png";

import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import SecondaryButton from "../../components/button/SecondaryButton";
import PrimaryButton from "../../components/button/PrimaryButton";
import TopBanner from '../../components/layout/TopBanner';
import { setRegisterShop } from '../../features/register/RegisterShopSlice';
import { useDispatch, useSelector } from 'react-redux';
import TopLogo from '../../components/layout/TopLogo';
import InputLabel from '@mui/material/InputLabel';
import { SearchShopCode } from "../../services/Register";
import CustomPopup from '../../components/popup/CustomPopup';
import ErrorPopup from "../../components/popup/ErrorPopup";
import TransparentButton from "../../components/button/TransparentButton";
import backgroundSuccess from '../../assets/images/register/bg-success.png';
import { useLiff } from "react-liff";


export default function RegisterShop1() {
  const yesterday = new Date();
  const store = useSelector((state) => state.RegisterShop)
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [openCancelPopup, setOpenCancelPopup] = React.useState(false);
  const [popupTitle, setPopupTitle] = React.useState('')
  const [popupDesc, setPopupDesc] = React.useState('กรอกรหัสร้านค้าไม่ถูกต้อง\nกรุณาลองใหม่อีกครั้ง')

  const [openErrorPopup, setOpenErrorPopup] = React.useState(false);
  const { liff } = useLiff();

  const { register, formState: { errors }, handleSubmit, control, watch } = useForm({
    shouldFocusError: false,
    shouldUnregister: true,
    defaultValues: {
      address: store['address'],
      amphoeId: store['amphoeId'],
      deAddress: store['deAddress'],
      deAmphoeId: store['deAmphoeId'],
      deDistrictId: store['deDistrictId'],
      deProvinceId: store['deProvinceId'],
      deZipCode: store['deZipCode'],
      districtId: store['districtId'],
      isDeliveryAddress: store['isDeliveryAddress'],
      name: store['name'],
      provinceId: store['provinceId'],
      shopCode: store['shopCode'],
      shopId: store['shopId'],
      zipCode: store['zipCodee'],
      canOwner : store['canOwner']
    }
  });

  function fnSetData(name, value) {
    const tmpObj = {};
    tmpObj[name] = value;
    dispatch(setRegisterShop(tmpObj));
  }

  React.useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (name && type) {

        fnSetData(name, value[name]);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const onSubmit = (data) => {
    getSearchShopCode()
  };

  async function getSearchShopCode() {
    try {
      const { data } = await SearchShopCode(store['shopCode']);
      if (+data["resultCode"] === 20000) {
        fnSetData('address', data.body['addressDetails'])
        fnSetData('amphoe', data.body['amphoeName'])
        fnSetData('amphoeId', data.body['amphoeId'])
        fnSetData('deAddress', data.body['deAddressDetails'])
        fnSetData('deAmphoe', data.body['deAmphoeName'])
        fnSetData('deAmphoeId', data.body['deAmphoeId'])
        fnSetData('deSubDistrict', data.body['deDistrictName'])
        fnSetData('deSubDistrictId', data.body['deDistrictId'])
        fnSetData('deProvince', data.body['deProvinceName'])
        fnSetData('deProvinceId', data.body['deProvinceId'])
        fnSetData('deZipCode', data.body['deZipCode'])
        fnSetData('email', data.body['email'])
        fnSetData('isDeliveryAddress', data.body['isDeliveryAddress'])
        fnSetData('line', data.body['line'])
        fnSetData('mobileNumber', data.body['mobileNumber'])
        fnSetData('name', data.body['name'])
        fnSetData('subDistrict', data.body['districtName'])
        fnSetData('subDistrictId', data.body['districtId'])
        fnSetData('province', data.body['provinceName'])
        fnSetData('provinceId', data.body['provinceId'])
        fnSetData('shopCode', data.body['shopCode'])
        fnSetData('shopId', data.body['shopId'])
        fnSetData('zipCode', data.body['zipCode'])
        fnSetData('isOwner', data.body['canOwner'] ? true : false)
        fnSetData('canOwner', data.body['canOwner'])
        console.log(data)
        navigate("/register-shop-2", { state: data });
      } else if (+data["resultCode"] === 40400) {
        setPopupTitle('กรอกรหัสร้านค้าไม่ถูกต้อง');
        setPopupDesc('กรุณาลองใหม่อีกครั้ง');
        setOpenCancelPopup(true);
      }
    } catch (error) {
      console.log("postCreateMember error", error);
    }
  }



  React.useEffect(() => {
  }, []);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
        <ErrorPopup
          open={openErrorPopup}
          actionFunction={() => {
            setOpenErrorPopup(false)
          }}
        />
        <TopLogo />
        <TopBanner type="register" />
        <Container maxWidth="xl" className="mt-[-20px]">
          <div className="bg-white px-3">
            <img src={registerStep2} alt="logo" style={{ width: "100%" }} />
            <div style={{ fontSize: 30, textAlign: "center" }}>
              ลงทะเบียนสำหรับ
              <span style={{ fontWeight: "bold" }}> ร้านค้า</span>
            </div>
            <div style={{ textAlign: "center" }}>
              <img
                src={shop}
                alt="logo"
                style={{ width: "20%", display: "initial" }}
              />
            </div>
            <div style={{ padding: "0 10px" }}>
              <div className="flex gap-[10px] justify-start">
                <div className="primary-color title-size">รหัสร้านค้า</div>
                <div style={{ marginTop: "6px" }}>
                  <p className="sub-title-size">Shop Code</p>
                  <div className="blue-line" ></div>
                </div>
              </div>

              <p style={{ fontSize: "20px" }} className="text-left">กรอกรหัสร้านค้าของคุณ</p>
              <div className="">
                <InputLabel className="text-header1 text-left" htmlFor="txtShopCode">รหัสร้านค้า</InputLabel>
                <TextField
                  id="txtShopCode"
                  fullWidth
                  error={!!errors?.shopCode}
                  helperText={errors?.shopCode?.message}
                  {...register("shopCode", { required: "กรุณากรอกรหัสร้านค้า" })}
                  placeholder="HE0001"
                />
              </div>
              <div className={!errors.shopCode ? "mt-3" : "mt-7"}>
                <p style={{ fontSize: "20px" }} className="text-center" htmlFor="txtEmail">สามารถรับรหัสร้านค้าได้ที่ตัวแทนบริษัทฯ หรือติดต่อ </p>
              </div>
              <div className="flex gap-[5px] justify-center">
                <img style={{ width: "20px", height: "19.06px" }} src={lineIcon}></img> <p style={{ fontSize: "20px", fontWeight: "bold", marginTop: "-5px" }}> @haierthailand</p>
              </div>
              <br></br>
            </div>
          </div>
        </Container>
        <div className="bg-white mt-[20px] h-[100px] pt-[25px]">
          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <SecondaryButton variant="outlined" className="w-[40%]" onClick={() => navigate('/register')}>
              ย้อนกลับ
            </SecondaryButton>
            <PrimaryButton variant="contained" className="w-[40%]" type="submit">
              ต่อไป
            </PrimaryButton>
          </Stack>
        </div>
      </form>

      <CustomPopup
        title={popupTitle}
        desc={popupDesc}
        cancelText="ปิด"
        cancelFunction={() => {
          setOpenCancelPopup(false);
        }}
        open={openCancelPopup}
        onClose={() => {
          // setOpenCancelPopup(false);
        }}
      />

    </>
  //   <>
  //   <TopLogo />
  //   <div
  //     style={{
  //       background: `url(${backgroundSuccess}) no-repeat center center fixed`,
  //       minHeight: "calc(100vh - 60px)",
  //       backgroundSize: "cover",
  //       paddingTop: "25px",
  //       paddingBottom: "25px"
  //     }}
  //   ></div>
  //   <div className="leading-[34px] text-[34px] no-event text-white text-center">
  //     <p className="mb-[200px]">
  //       ติดตามกิจกรรมใหม่ๆ <br></br> ของ Haier Privilege <br></br> ผ่านทาง Social media  <br></br> ของเราได้เลยครับ
  //       พบกันเร็ว ๆ นี้
  //     </p>
  //     <TransparentButton
  //       className="w-[80%]"
  //       variant="outlined"
  //       onClick={() => liff.closeWindow()}
  //     >
  //       <p>ย้อนกลับ</p>
  //     </TransparentButton>
  //   </div>

  // </>
  );
}
